var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40015 0L10.0001 7.524L18.5991 0H1.40015Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.643066 0.799988V13.51L7.90607 7.15499L0.643066 0.799988Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0891 7.15499L19.3521 13.51V0.799988L12.0891 7.15499Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2581 7.88699L10.3581 8.67099L10.3501 8.66199C10.2534 8.7534 10.1258 8.80499 9.99271 8.80647C9.85963 8.80795 9.73089 8.75922 9.63215 8.66999L8.73215 7.88699L1.40015 14.311H18.6001L11.2581 7.88699Z",
    fill: "#1C1C1C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2c8a70ffeeed77d826d7a099662e9d55.svg";
export { ForwardRef as ReactComponent };